import React, { useMemo } from "react"
import tw from "twin.macro"
import Image from "next/image"
import Link from "next/link"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

export interface EmbedCardProps {
  title: string
  deck: any
  body: any
  image: any
  url: string
}

export default function EmbedFullWidth(props: EmbedCardProps) {
  const { url, body } = props
  const bodyJson = body.json
  const bodyText = useMemo(() => {
    return documentToReactComponents(bodyJson)
  }, [body])

  const imageUrl = props.image.url
  const imageTitle = props.image.title
  const imageWidth = props.image.width
  const imageHeight = props.image.height
  const placeholderImgUrl = imageUrl + "?w=25&h=25"

  const altText = imageTitle
    ? `${imageTitle} – The Richard Pousette-Dart Foundation`
    : `The Richard Pousette-Dart Foundation`

  const card = (
    <div tw="py-8 mx-auto flex flex-col max-w-screen-widescreen">
      <Image
        src={imageUrl}
        height={imageHeight}
        width={imageWidth}
        alt={altText}
        placeholder="blur"
        blurDataURL={placeholderImgUrl}
      />
      {bodyText && <div className="caption">{bodyText}</div>}
    </div>
  )

  if (!url) {
    return <>{card}</>
  }
  return (
    <Link className="embedLarge" href={url}>
      {card}
    </Link>
  )
}
